import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { PageHero, FeatureGrid, CTABand } from "@/components/public/PageHero";
import { Handshake, Stethoscope, Scale, Building2, Repeat, ShieldCheck } from "lucide-react";

const FEATURES = [
  { icon: Stethoscope, title: "Healthcare & discharge teams", body: "A reliable partner for social workers and case managers coordinating safe transitions home." },
  { icon: Scale, title: "Attorneys & fiduciaries", body: "Elder-law attorneys and POAs get a trusted, organized guide for their clients' moves." },
  { icon: Building2, title: "Senior communities", body: "We help families arrive prepared, informed, and ready for a confident placement decision." },
  { icon: Repeat, title: "Two-way referrals", body: "Refer families to us with confidence — and receive warm referrals back when it fits." },
  { icon: ShieldCheck, title: "Vetted & accountable", body: "Every partner in our network is screened, and every family gets dedicated follow-through." },
  { icon: Handshake, title: "Simple to work with", body: "One point of contact, clear communication, and updates you can count on." },
];

export default function ForProfessionals() {
  const { content } = useOutletContext();
  useEffect(() => { document.title = "For Professionals · MovingMyMama"; }, []);
  const img = content?.services?.items?.[3]?.image_url || content?.hero?.image_url;
  return (
    <div data-testid="for-professionals-page">
      <PageHero
        eyebrow="For Professionals"
        title="A trusted partner for the families you serve."
        subtitle="Social workers, attorneys, senior communities, and advisors rely on us to guide families through complex senior transitions with care and clarity."
        image={img}
        ctaLabel="Become a referral partner"
        ctaHref="/contact"
      />
      <FeatureGrid items={FEATURES} />
      <CTABand
        title="Let's build a partnership."
        subtitle="Reach out and we'll set up a quick call to see how we can support your clients."
        ctaLabel="Contact our partnerships team"
        ctaHref="/contact"
      />
    </div>
  );
}
